import { render } from "./header.vue?vue&type=template&id=2fd48809&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=2fd48809&lang=less&scoped=true"

import exportComponent from "E:\\交接项目\\基立福\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd48809"]])

export default __exports__